
import { Component, Mixins, Watch } from 'vue-property-decorator';
import scroll from '@/mixins/scroll';
import Address from '@/views/shelf/components/address.vue'
import Price from '@/components/Price/index.vue'
import {
  getStoreOrder,
} from '@/api/industryMall';
import { Getter } from 'vuex-class';
import { getCurrentOrder, getTomorrowOrder, getHistoryOrder, getOrderDtl, exportOrderList, storeWriteOff } from '@/api/ccx'
import SearchBar from '@/components/SearchBar/index.vue'
import ExportDataPopup from '@/views/jielongOrder/components/ExportDataPopup.vue'
import TipsPopup from '@/components/tipsPopup/index.vue'
import { shareFileToWeixin } from '@/utils/h5ToApp'

enum SearchField {
  all = 'all',
  notWriteOff = 'notWriteOff',
  writeOff = 'writeOff',
}

@Component({
  name: 'SalesSilp',
  components: {
    Address,
    Price,
    SearchBar,
    ExportDataPopup,
    TipsPopup
  }
})
export default class SalesSilp extends Mixins(scroll) {
  @Getter companyId!: string;
  @Getter whiteStrips!: number;

  tabKeys = '1';
  showDetail = false; // 展示明细
  error = false;
  showExportPopup = false;
  goodsExportList = [
    {
      goodsName: '大白菜(1份)',
      num: 38,
      price: 189.62,
      personNum: 10,
      arriveDate: '05月20日'
    },
    {
      goodsName: '鲜牛肉(1kg)',
      num: 55,
      price: 2304.5,
      personNum: 20,
      arriveDate: '05月20日'
    }
  ];
  orderExportList = [
    {
      customerName: '张** (18823396271)',
      goodsName: '大白菜(1份)',
      num: 2,
      remark: '123456',
      orderStatus: '未核销'
    },
    {
      customerName: '张** (18823396271)',
      goodsName: '大白菜(1份)',
      num: 2,
      remark: '',
      orderStatus: ''
    }
  ];

  tabActions = [
    { text: '今日', value: '1', id: 1 },
    { text: '明日', value: '2', id: 2 },
    { text: '历史', value: '3', id: 3 },
  ];

  refreshing = false;
  loading = false;
  finished = false;
  queryContent = '';
  searchName = '全部分类';
  showClassify = false;
  searchType: SearchField = SearchField.all;
  tempParams: { searchType: SearchField } = {
    searchType: SearchField.all,
  };
  classify = [
    {
      title: '核销状态',
      propName: 'searchType',
      options: [
        { label: '全部', value: SearchField.all },
        { label: '未核销', value: SearchField.notWriteOff },
        { label: '已核销', value: SearchField.writeOff },
      ],
    },
  ];
  params: any = {
    storeId: '',
    // 搜索关键词
    keyword: '',
    // 核销状态：'' 全部 / 0 未核销 / 1 已核销
    writeOff: '',
    pageIndex: 1,
    pageSize: 20,
  };
  orderList = [];
  controller: any;
  clickedItemIndex = 0;
  isActivated = false;
  dataDetail: any = {}; // 明细数据
  Api: any = getCurrentOrder;
  sftpUrl = ''

  created() {
    this.params.storeId = this.companyId;
    this.tempParams = { searchType: this.searchType };
    this.getSearchName();
    const { orderType, payType } = this.$route.query;
    if (orderType || payType) {
      const next = (orderType as string) || (payType as string);
      if (next === this.tabKeys) {
        this.handleTabKeys();
      } else {
        this.tabKeys = next; // 由 watch 拉列表
      }
    } else {
      this.handleTabKeys();
    }
  }

  mounted() {
    this.$addScrollListener('.van-tabs__content');
    this.sftpUrl = this.$store.state.user.sftpUrl
  }

  closeShowDetail() {
    this.showDetail = false;
  }

  activated() {
    if (this.isActivated) {
      this.handleActivated();
      this.$setScrollY();
    } else {
      this.isActivated = true;
    }
  }

  deactivated() {
    this.$removeScrollListener();
  }

  /**
   * @description 从订单详情返回刷新当前页数据，当前页之后的数据清除
   **/
  handleActivated() {
    const pageIndex =
      Math.trunc(this.clickedItemIndex / this.params.pageSize) + 1;
    const params = { ...this.params, pageIndex };
    getStoreOrder(params).then((res) => {
      if (pageIndex > 1) {
        const preData = this.orderList.slice(
          0,
          (pageIndex - 1) * this.params.pageSize
        );
        const data = preData.concat(res.data.records);
        this.orderList = JSON.parse(JSON.stringify(data));
      } else {
        this.orderList = res.data.records;
      }
      this.params.pageIndex = pageIndex;
      if (Number(pageIndex) >= res.data.totalPages) {
        this.finished = true;
      } else {
        this.finished = false;
      }
    });
  }

  @Watch('tabKeys')
  handleTabKeys() {
    if (this.tabKeys === '1') {
      this.Api = getCurrentOrder
    } else if (this.tabKeys === '2') {
      this.Api = getTomorrowOrder
    } else {
      this.Api = getHistoryOrder
    }
    this.params.pageIndex = 1;
    this.finished = false;
    this.loading = true;
    this.orderList = [];
    if (this.controller) {
      this.controller.abort();
    }
    this.getOrderList();
  }

  /** 拼接分类按钮文案 */
  getSearchName() {
    const typeVal = this.tempParams.searchType;
    const typeOption = this.classify[0].options.find(opt => opt.value === typeVal);
    if (typeVal === SearchField.all) {
      this.searchName = '全部分类';
      return this.searchName;
    }
    this.searchName = typeOption?.label || '全部分类';
    return this.searchName;
  }

  /** 将搜索词与核销筛选落到请求字段 */
  private applySearchParams() {
    this.params.keyword = (this.queryContent || '').trim();
    if (this.searchType === SearchField.writeOff) {
      this.params.writeOff = 1;
    } else if (this.searchType === SearchField.notWriteOff) {
      this.params.writeOff = 0;
    } else {
      this.params.writeOff = '';
    }
  }

  onSearch() {
    this.showClassify = false;
    this.searchType = this.tempParams.searchType;
    this.getSearchName();
    this.applySearchParams();
    this.params.pageIndex = 1;
    this.finished = false;
    this.loading = true;
    this.orderList = [];
    this.getOrderList();
  }

  popupClose() {
    this.showClassify = false;
    this.tempParams = {
      searchType: this.searchType,
    };
  }

  popupOpen() {
    this.showClassify = true;
    this.tempParams = {
      searchType: this.searchType,
    };
  }

  selectOption(value: SearchField, propName: string) {
    this.$set(this.tempParams, propName, value);
  }

  /**
   * @description 关联退单
   *
   */
  goReturnList(list) {
    // 确保订单列表页面刷新
    this.$eventBus.$emit('refreshStatus', {
      status: '退款申请',
      orderId: list.orderId,
    });
  }

  getOrderList() {
    this.Api({ ...this.params })
      .then((res) => {
        this.error = false;
        if (this.refreshing || this.params.pageIndex === 1) {
          this.orderList = [];
        }

        const orderList = this.orderList.concat(res.data.records) || [];
        this.orderList = JSON.parse(JSON.stringify(orderList));
        if (Number(this.params.pageIndex) >= res.data.totalPages) {
          this.finished = true;
        } else {
          this.finished = false;
        }
      })
      .catch(() => {
        this.error = true;
        this.params.pageIndex = 0;
      })
      .finally(() => {
        this.loading = false
        this.refreshing = false
      });
  }

  /**
   * 下拉刷新
   * */
  onRefresh() {
    this.params.pageIndex = 1;
    this.refreshing = true;
    if (this.controller) {
      this.controller.abort();
    }
    this.getOrderList();
  }

  /**
   * 上拉加载更多
   */
  onLoad() {
    this.params.pageIndex++;
    this.getOrderList();
  }
  showDetails(item) {
    getOrderDtl({ storeId: this.companyId, orderId: item.orderId }).then(res => {
      this.showDetail = true;
      this.dataDetail = res.data;
    })
  }

  onWriteOff(item) {
    (this.$refs.tipsPopupRef as any).showPopup(item)
  }

  onWriteOffConfirm(item) {
    storeWriteOff({
      orderId: item.orderId,
      storeId: this.companyId || this.params.storeId
    }).then(() => {
      this.$toast.success('核销成功')
      this.onRefresh()
    })
  }

  handleDate (time: string) {
    if (!time) return ''
    let arr = time.split('-')
    return `${arr[0]}年${arr[1]}月${arr[2]}日`
  }

  showGoodsList(list: any) {
    (this.$refs.goodsList as any).showPop(list);
  }

  onExport() {
    if (!this.orderList.length) {
      this.$toast({
        message: '暂无订单数据',
      })
      return
    }
    this.showExportPopup = true
  }

  onExportDownload(activeTab: number) {
    const orderStatus = activeTab === 0 ? 1 : 2 // 1按商品，2按订单
    const typeName = orderStatus === 1 ? '按商品导出' : '按订单/客户导出'
    const now = new Date()
    const month = now.getMonth() + 1
    const day = now.getDate()
    const dateStr = `${now.getFullYear()}${month < 10 ? '0' + month : month}${day < 10 ? '0' + day : day}`
    const title = `次日达${typeName}${dateStr}`
    exportOrderList({
      storeId: this.companyId || this.params.storeId,
      orderDate: Number(this.tabKeys), // 1今日，2明日
      orderStatus
    }).then((res: any) => {
      const blob = new Blob([res.data], { type: 'application/octet-stream' })
      const reader = new FileReader()
      reader.onload = function(e: any) {
        const base64String = e.target.result.split(',')[1]
        shareFileToWeixin({
          fileBase64: base64String,
          title,
          fileExtension: 'xlsx',
          scene: 'session'
        })
      }
      reader.readAsDataURL(blob)
    })
  }
}
